import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/parts/actions";
import AutoComplete from "MODULES/shared/components/AutoComplete/AutoComplete";
import classNames from "classnames";
import { CompanyStatsTooltip } from "APP_ROOT/modules/shared/components";

export function SearchCompanyName({
  autoFocus,
  search,
  onSelect,
  selectedCompany,
  company,
  company_id: { meta: { touched, error, invalid }, input: { value } },
  type = "default",
  disabled
}) {
  const errors =
    touched &&
    invalid &&
    error.map(m => (
      <span className="help-block" key={m}>
        {m}
      </span>
    ));

  const classes = classNames({
    "has-error": touched && invalid
  });

  const companyLabels = {
    default: "Vendor",
    outgoingQuote: "Customer",
    repairOrder: "Repair Station",
    salesOrder: "Customer"
  };

  const label = companyLabels[type];
  const tooltipContext = type === "repairOrder" ? "repair" : "standard";

  return (
    <div className={classes}>
      <label className="control-label" htmlFor="company_id">
        {label}
        <sup className="small text-danger">*</sup>
        {company && (
          <React.Fragment>
            &nbsp;&nbsp;
            <CompanyStatsTooltip company={company} context={tooltipContext} />
          </React.Fragment>
        )}
      </label>
      <AutoComplete
        autoFocus={autoFocus}
        key="autoCompleteCompany"
        value={selectedCompany ? selectedCompany.name : ""}
        hasId={value}
        search={search}
        onSelect={onSelect}
        format={result => result.name}
        placeholder="Search by typing a company's name or code"
        disabled={disabled}
      />
      {errors}
    </div>
  );
}

SearchCompanyName.propTypes = {
  autoFocus: PropTypes.bool,
  search: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedCompany: PropTypes.shape({
    name: PropTypes.string
  }),
  company: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  company_id: PropTypes.shape({}),
  type: PropTypes.bool,
  disabled: PropTypes.bool
};

export default connect(undefined, (dispatch, ownProps) => ({
  search: filter => {
    const search = ownProps.companySearch || actions.searchCompanies;
    return dispatch(search()(filter));
  }
}))(SearchCompanyName);



// WEBPACK FOOTER //
// ./app/modules/companies/shared/FindOrCreateCompanyToggle/SearchCompanyName.jsx